/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {dlsColor} from '../../theme/theme';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) Filter Drawer Favorite Icon component.
 */
export const FilterDrawerFavoriteIcon = ({
  color = dlsColor('grey2')
}: IconProps) => {
  const {iconSize, iconColor} = useIconDLS({color});
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M15.7139 5.75C17.6509 5.75 19.25 7.35776 19.25 9.36035C19.25 9.90328 18.9991 10.4769 18.6855 10.9658C18.3824 11.4383 18.0725 11.7516 18.0586 11.7656L18.0557 11.7686L11.999 17.9297L5.94043 11.7656L5.9375 11.7627L5.7373 11.5391C5.62041 11.4001 5.46591 11.2026 5.31348 10.9648C5.00037 10.4763 4.75002 9.9032 4.75 9.36035C4.75 7.35776 6.34906 5.75 8.28613 5.75C9.64452 5.75018 10.8551 6.63101 11.4951 7.21387L12 7.67383L12.5049 7.21387C13.1449 6.631 14.3555 5.75018 15.7139 5.75Z' stroke={iconColor} strokeWidth='1.5' />
    </svg>
  );
};

export default FilterDrawerFavoriteIcon;
